
import ReactDOM from 'react-dom/client';

import NFLTeamPage from './components/NFLTeamPage'
import MLBTeamPage from './components/MLBTeamPage'

const App = ({ sportcode, teamid }) => {
    
    if (sportcode === "NFL") {
        
        return <NFLTeamPage sportcode={sportcode} teamid={teamid} />
    }
    else {
        return <MLBTeamPage sportcode={sportcode} teamid={teamid} />
    }
}

const container = document.getElementById('app');
const sportcode = container.getAttribute("sportcode");
const teamid = container.getAttribute("data-teamid");
const root = ReactDOM.createRoot(container);

root.render(<App sportcode={sportcode} teamid={parseInt(teamid)} />);